import { render } from "./SingleMainComponent.vue?vue&type=template&id=6eb94faa"
import script from "./SingleMainComponent.vue?vue&type=script&lang=js"
export * from "./SingleMainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__